export class CoasVideoPreview {
    constructor(containerVideoId) {
        this.containerVideoId = containerVideoId;
    }
    onInit() {
        const containerVideo = document.getElementById(this.containerVideoId);
        if (!containerVideo)
            return console.log(`Not element fount with '${this.containerVideoId}' Id`);
        const imgPreview = containerVideo.getAttribute('srcImg');
        const ytVideoCode = containerVideo.getAttribute('srcVideoCode');
        if (!ytVideoCode)
            return console.log(`Not YT code with '${ytVideoCode}' value`);
        if (!imgPreview || imgPreview == "") {
            const internalContent = `<iframe title="YouTube video player" src="https://www.youtube.com/embed/${ytVideoCode}?autoplay=0&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
            containerVideo.innerHTML = internalContent;
        }
        else {
            // Creamos la estructura interna
            const internalContent = `<div class="video-container-image">` +
                `<img class="relative z-10 w-full" src="${imgPreview}" loading="lazy" alt="landing video">` +
                `</div>` +
                `<div id=${ytVideoCode}></div>`;
            containerVideo.innerHTML = internalContent;
            // Agregamos el evento click de la imagen
            const myImage = containerVideo.querySelector('div.video-container-image');
            myImage && this.clickPosterVideo(myImage, ytVideoCode, containerVideo);
        }
    }
    clickPosterVideo(imageReference, ytVideoCode, containerVideo) {
        const landingPosterVideo = imageReference;
        landingPosterVideo && landingPosterVideo.addEventListener('click', () => {
            var _a;
            landingPosterVideo.style.opacity = '0';
            (_a = containerVideo.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add("played");
            this.onYouTubeIframeAPIReady(ytVideoCode);
        });
    }
    onYouTubeIframeAPIReady(videoID) {
        this.player = new window.YT.Player(videoID, {
            videoId: `${videoID}`,
            playerVars: {
                'autoplay': 1,
                'origin': `${window.location.href}`
            },
        });
    }
}
